import { ErrorContainer } from "../../components/errors/ErrorContainer";

export default function PageNotFound() {
  return (
    <ErrorContainer
      status={500}
      text="Es gab einen internen Fehler"
      subtext="Bitte versuchen Sie es in Kürze erneut oder melden Sie das Problem der Administration"
    />
  );
}
